import Actions from './account-actions';
import Api from './account-api';
import Model from './account-model';
import reducer from './account-reducer';
import sagas from './account-sagas';
import Selectors from './account-selectors';

export default {
  Actions,
  Api,
  Model,
  namespace: 'account',
  reducer,
  sagas:     [sagas],
  Selectors,
};
